import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { CopyCompanyContainer } from './styled'
import { getPaymentBlocks, getPaymentMethods, getPaymentTerms, getSortKeys, getWhtTypes, 
  getWhtReceiptTypes, getReconciliations, getPlanningGroups, getTradingPartners } from 'ducks/options'
import { getBPAccountingView } from 'ducks/vendorMaintenance'
import r from 'reactotron-react-js'

const CopyCompanyForm = (props) => {
  const { valueForm, change, setShowCompanyForm, companies, paymentBlocks, paymentMethods, paymentTerms, 
    sortKeys, whtTypes, whtReceiptTypes, reconciliations, planningGroups, tradingPartners } = props
  
  useEffect(() => {
    if (!paymentBlocks.data.length && !paymentBlocks.loading) {
      props.getPaymentBlocks()
    }

    if (!paymentMethods.data.length && !paymentMethods.loading) {
      props.getPaymentMethods()
    }

    if (!paymentTerms.data.length && !paymentTerms.loading) {
      props.getPaymentTerms()
    }
    
    if (!sortKeys.data.length && !sortKeys.loading) {
      props.getSortKeys()
    }

    if (!whtTypes.data.length && !whtTypes.loading) {
      props.getWhtTypes()
    }

    if (!whtReceiptTypes.data.length && !whtReceiptTypes.loading) {
      props.getWhtReceiptTypes()
    }

    if (!planningGroups.data.length && !planningGroups.loading) {
      props.getPlanningGroups ()
    }

    if (!tradingPartners.data.length && !tradingPartners.loading) {
      props.getTradingPartners()
    }

    if (valueForm.reconciliationAccount === undefined || 
        valueForm.reconciliationAccount === '' || 
        valueForm.reconciliationAccount === null) {
      props.getBPAccountingView(valueForm.vendorCode, valueForm.companyCode, onLoadAccountingViewSuccess)
    }
  }, [])

  useEffect(() => {
    if (valueForm.companyCode !== undefined) {
      if (reconciliations.companyCode !== valueForm.companyCode) {
        props.getReconciliations(valueForm.companyCode)
      }
    }
  }, [valueForm.companyCode])

  const onLoadAccountingViewSuccess = (data) => {
    const getBoolValue = (value, defaultValue) => {
      return (value !== undefined && value !== null && value !== '') ? value : defaultValue
    }

    change('reconciliationAccount', data.reconciliationAccount || '')
    change('sortKey', data.sortKey || '')
    change('planningGroup', data.planningGroup || '')
    change('accPaymentTerms', data.accPaymentTerms || '')
    change('paymentMethod', data.paymentMethod || ['C', 'E', 'T', 'P', 'B', 'K'])
    change('paymentBlock', data.paymentBlock || '')
    change('tradingPartner', data.tradingPartner || '')
    change('previousAccount', data.previousAccount || '')
    change('checkDoubleInvoice', getBoolValue(data.checkDoubleInvoice, false))
    change('payeeInDocument', getBoolValue(data.payeeInDocument, false))
    change('withholdingTaxs', [...(data.withholdingTaxs || [])])
    change('branchCode', data.branchCode || '')
    change('branchDescription', data.branchDescription || '')
    change('accountingViewLoaded', true)
  }

  const GetTextFromOption = (options, value) => {
    if (value === null || value === undefined || value === '') return '-'
    var x = options.data.find(x => x.value === value)
    return x ? x.text : value
  }

  const GetTextFromPaymentMethod = (value) => {
    if (value === null || value === undefined || value === '') return '-'
    
    var paymentMethodValue = ''
    value.forEach(x => {
      var y = paymentMethods.data.find(z => z.value === x)
      if ( y !== null && y !== undefined) {
        if (paymentMethodValue === '') {
          paymentMethodValue = y.text
        } else {
          paymentMethodValue = `${paymentMethodValue}<br /> ${y.text}`
        }
      }
    })
    
    return paymentMethodValue
  }

  const LabelAndValue = (label, value) => {
    return (
      <tr>
        <td style={{ verticalAlign: 'top', fontWeight: 'bold' }}>{label}</td>
        <td style={{ verticalAlign: 'top' }}><div dangerouslySetInnerHTML={{__html: value}} /></td>
      </tr>
    )
  }

  return (
    <CopyCompanyContainer>
      <div className='companySection'>
        <div className='sourceCompany'>
          <div className='subTitle'>Source Company</div>
          <table>
            {LabelAndValue('Company', GetTextFromOption(companies, valueForm.companyCode))}
            {/* {LabelAndValue('Reconciliation Account', GetTextFromOption(reconciliations, valueForm.reconciliationAccount))}
            {LabelAndValue('Sort Key', GetTextFromOption(sortKeys, valueForm.sortKey))}
            {LabelAndValue('Planning Group', GetTextFromOption(planningGroups, valueForm.planningGroup))}
            {LabelAndValue('Payment Terms', GetTextFromOption(paymentTerms, valueForm.accPaymentTerms))}
            {LabelAndValue('Payment Method', GetTextFromPaymentMethod(valueForm.paymentMethod || []))}
            {LabelAndValue('Payment Block', GetTextFromOption(paymentBlocks, valueForm.paymentBlock))}
            {LabelAndValue('Trading Partner', GetTextFromOption(tradingPartners, valueForm.tradingPartner))}
            {LabelAndValue('Previous Account', valueForm.previousAccount || '-')}
            {LabelAndValue('Check Double Invoice', valueForm.checkDoubleInvoice ? 'Yes' : 'No')}
            {LabelAndValue('Payee In Document', valueForm.payeeInDocument ? 'Yes' : 'No')} */}
          </table>
        </div>
        <div className='destinationCompany'>
          <div className='subTitle'>
            Destination Companies
            <Field name='companies' label='' require type={type.labelOnly} component={FieldInput} />
          </div>
          {
            valueForm.status === 4 ? null : 
              <div className='rowFields' style={{ marginBottom: '1rem', flex: 'unset' }}>
                <Button 
                  color='blue'
                  content='Select Company'
                  type='button'
                  disabled={(
                    valueForm.vendorCode === undefined ||
                    valueForm.vendorCode === null ||
                    valueForm.vendorCode === '' ||
                    valueForm.status === 4
                  )}
                  style={{ flex: 1 }}
                  onClick={() => setShowCompanyForm(true)}
                />
              </div>
          }
          {
            <table>
              {
                (valueForm.companies || []).length > 0 ?
                  valueForm.companies.sort((a, b) => a.localeCompare(b)).map((c, index) => {
                    return (
                      LabelAndValue(index === 0 ? (valueForm.companies || []).length > 1 ? 'Companies' : 'Company' : '', GetTextFromOption(companies, c))
                    )
                  }) : null
              }
            </table>
          }
        </div>
      </div>
    </CopyCompanyContainer>
  )
}
const mapStateToProps = (state) => {
  return ({
    paymentBlocks: state.options.paymentBlocks,
    paymentMethods: state.options.paymentMethods,
    paymentTerms: state.options.paymentTerms,
    sortKeys: state.options.sortKeys,
    whtTypes: state.options.whtTypes,
    whtReceiptTypes: state.options.whtReceiptTypes,
    reconciliations: state.options.reconciliations,
    planningGroups: state.options.planningGroups,
    tradingPartners: state.options.tradingPartners,
  })
}
  
const mapDispatchToProps = {
  getPaymentBlocks,
  getPaymentMethods,
  getPaymentTerms,
  getSortKeys,
  getWhtTypes, 
  getWhtReceiptTypes,
  getReconciliations,
  getPlanningGroups, 
  getTradingPartners,
  getBPAccountingView
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyCompanyForm)